var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "15",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_65_93734)" } }, [
        _c("path", {
          attrs: {
            d: "M9.42503 10.5104C10.1834 10.402 10.8667 9.97147 11.2917 9.31869L15.7834 2.37147C16.1334 1.8298 16.0445 1.11314 15.5722 0.67147C15.1 0.229803 14.3806 0.190914 13.8639 0.579803L7.28892 5.51314C6.62225 6.01314 6.22781 6.79369 6.22225 7.62703L9.42503 10.5104ZM8.88058 11.2159L5.65836 8.31592C3.99725 8.37703 2.66669 9.74647 2.66669 11.4242C2.66669 11.5326 2.67225 11.6409 2.68336 11.7465C2.73336 12.2326 2.40003 12.7576 1.91114 12.7576H1.7778C1.28614 12.7576 0.888916 13.1548 0.888916 13.6465C0.888916 14.1381 1.28614 14.5354 1.7778 14.5354H5.7778C7.49725 14.5354 8.88892 13.1437 8.88892 11.4242C8.88892 11.3548 8.88614 11.2854 8.88336 11.2159H8.88058Z",
            fill: "black",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_65_93734" } }, [
          _c("rect", {
            attrs: {
              width: "16",
              height: "14.2222",
              fill: "white",
              transform: "translate(0 0.313232)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }